import { render } from "./GKObjectImageCarousel.vue?vue&type=template&id=0dc8e1e8&scoped=true"
import script from "./GKObjectImageCarousel.vue?vue&type=script&lang=js"
export * from "./GKObjectImageCarousel.vue?vue&type=script&lang=js"

import "./GKObjectImageCarousel.vue?vue&type=style&index=0&id=0dc8e1e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc8e1e8"]])

export default __exports__